const REWARD_TYPE = {
  BONUS_POINTS: 'A',
  FOOD_CREDIT: 'F',
  FREE_PLAY: 'P',
  SHOPPING_DOLLARS: 'shopping-dollars',
  HOTEL_STAY: 'R',
  WSTORE_EARLY_ACCESS: 'WStoreEarlyAccess',
  DRAWING_TICKET: 'DrawingTicket',
  WSCORE: 'WScore',
  OF_NO_ACTION: 'OF - No Action',
  DEFAULT: 'default'
};

const WCH_HOTEL = 'WCHHOTEL';

const ROLLING_OFFER_CODES = [WCH_HOTEL];

export function isRollingOfferCode(prizeCode) {
  return ROLLING_OFFER_CODES.includes(prizeCode);
}

export function isWebOfferPrizeCode(prizeCode) {
  if (!prizeCode) {
    return false;
  }

  return prizeCode.startsWith('@') || prizeCode.startsWith('C!H');
}

export { REWARD_TYPE, WCH_HOTEL };
